module.exports = __webpack_public_path__ + "img/icon_nav_summaries.3518df5.svg";